import { Box, Grid, Typography } from "@material-ui/core"
import { EnumSexo } from "api/cardapio/models/pessoa/pessoa-model"
import { DefaultCard } from "components/default-card"
import React, { useCallback, useState } from "react"
import { useStyles } from "./sexo-identificacao-styles"
import { SexoIdentificacaoProps } from "./sexo-identificacao-props"
import { RadioSelecionadoIcon } from "components/icons/radio-selecionado-icon"
import { RadioVazioIcon } from "components/icons/radio-vazio-icon"

export const SexoIdentificacao = ({ valueChanged }: SexoIdentificacaoProps) => {
    const classes = useStyles()
    const [value, setValue] = useState<EnumSexo>(EnumSexo.NaoInformado)
    const handleChanged = useCallback((sexo: EnumSexo) => {
        valueChanged(sexo)
        setValue(sexo)
    }, [valueChanged, setValue])

    const SelecaoSexo = ({ vSexo }: { vSexo: EnumSexo }) => {

        const sexoLabels = {
            [EnumSexo.Masculino]: "Masculino",
            [EnumSexo.Feminino]: "Feminino",
            [EnumSexo.NaoInformado]: "Não Informar",
        }
        const sexoLabel = sexoLabels[vSexo]

        return (
            <DefaultCard hasTagStatus={false} onClick={async () => {
                if (value !== vSexo) {
                    handleChanged(vSexo)
                }
            }} >
                <Box display={"flex"} alignItems="center" width="100%">
                    <Grid className={classes.radio}>
                        {value === vSexo && <RadioSelecionadoIcon tipo="BUTTON" />}
                        {value !== vSexo && <RadioVazioIcon tipo="BUTTON" />}
                    </Grid>
                    <Typography className={classes.text} variant="h5" align='center'>
                        {sexoLabel}
                    </Typography>
                </Box>
            </DefaultCard>
        )
    }

    return (
        <Box p={1}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <SelecaoSexo vSexo={EnumSexo.NaoInformado} />
                </Grid>
                <Grid item xs={12}>
                    <SelecaoSexo vSexo={EnumSexo.Masculino} />
                </Grid>
                <Grid item xs={12}>
                    <SelecaoSexo vSexo={EnumSexo.Feminino} />
                </Grid>
            </Grid>
        </Box>
    )
}